import $ from 'jquery'
import messageResource from './messageResource'
import UserTime from './user_time'
import WorkdayDurationsEditor from './controls/WorkdayDurationsEditor'
import RpcControlManager from './rpc_control_manager'
import {BalanceRulesEditor} from './controls/BalanceRulesEditor'
import TimeZonesSelector from './controls/TimeZonesSelector'
import BalanceRulesEditorContent from './controls/BalanceRulesEditorContent'
import {LeaveBalanceUnits} from 'constants'
import {trim} from './atUtils'
import {DateFormat} from './date_format'
import ClientSideErrors from './client_side_errors'
import PtoLowBalanceSettingsContainer from './administration/lowBalanceSettings/pto/PtoLowBalanceSettingsContainer'
import SdbLowBalanceSettingsContainer from './administration/lowBalanceSettings/sdb/SdbLowBalanceSettingsContainer'

const SystemSettings = window.SystemSettings

window.workdayDurationsEditor = null;
window.ptoRulesEditor = null;
window.sickRulesEditor = null;

window.scheduleModificationsHandler = null;
window.defaultWDModificationsHandler = null;
window.sectionsStateController = null;

/**
 * Holds list of settings blocks, for each block there is known status:
 *  - modified or not
 *  - valid or not
 *  Outside block controllers may call onModify/onSave methods in order to update overall settings page state
 */
var ValidatableFormBlocks = {

    blocks: new Map(),

    register(blockId) {
        this.blocks.set(blockId, {blockId, valid: true, modified: false});
        return {
            onModify: valid => this.onModifyBlock(blockId, valid),
            onSave: () => this.onSaveBlock(blockId)
        }
    },

    hasAnyErrors() {
        let valid = true;
        for (let p of this.blocks.values()) {
            valid = valid && p.valid;
        }
        return !valid;
    },

    anyBlockModified() {
        let modified = false;
        for (let p of this.blocks.values()) {
            modified = modified || p.modified;
        }
        return modified;
    },

    getErrorBlockIds() {
        let ids = [];
        for (let p of this.blocks.values()) {
            if (!p.valid) ids.push(p.blockId);
        }
        return ids;
    },

    /**
     * Marks block as modified. Sets settings page modified state
     * @param id block id
     * @param valid is valid after modification (if not - submit denied)
     */
    onModifyBlock(id, valid) {
        let block = this.blocks.get(id);
        block.valid = valid;
        block.modified = true;

        hilightButtonPane();
        showModifiedDiv();
    },

    /**
     * Marks block as not modified (maybe saved separately).
     * If no modified block remains - erases settings page modified state.
     * @param id block id
     */
    onSaveBlock(id) {
        let block = this.blocks.get(id);
        block.valid = true;
        block.modified = false;
        cancelModifications(this.anyBlockModified());
    }

};


function baseCanSubmit()
{
    defaultTZGroupNameController.hideGrayTextIfShown();

    if (!validateForm()
        || (ClientSideErrors.hasErrors())
        || workdayDurationsEditor.hasErrors()
        || (ptoRulesEditor != null && ptoRulesEditor.hasErrors())
        || (sickRulesEditor != null && sickRulesEditor.hasErrors())
        || ValidatableFormBlocks.hasAnyErrors())
    {
        ClientSideErrors.showClientSideErrorMessage();
        openSectionsWithErrors();
        return false;
    }

    return true;
}

function fillLeaveBalanceFormfromValues(prefix, values){
    for (var i=0; i<values.length; i++) {
        form().elements[prefix + values[i].name].value = values[i].value;
    }
}

function doSubmit()
{
    if (canSubmit())
    {
        var values;
        if ( ptoRulesEditor != null )
            fillLeaveBalanceFormfromValues("pto",ptoRulesEditor.getValues());

         if ( sickRulesEditor != null )
            fillLeaveBalanceFormfromValues("sick",sickRulesEditor.getValues());



        beforeSubmit();

        ExitConfirmation.disableConfirmationOnUnloadPage();

        if ( RpcControlManager.isRpcBusy() )
            RpcControlManager.cleanup();
        form().submit();
    }
    else
        form().redirectUrl.value = "";
}

function baseRegisterChangeable()
{
    confirmDlg = new ConfirmExitDlg(500, messageResource.getMessage("general_settings.edit.modification_not_finished_warning"),
                                    messageResource.getMessage("general_settings.edit.cancel_modification_confirm"),
                                    messageResource.getMessage("common.buttons.save_changes"), messageResource.getMessage("common.buttons.discard_changes"), messageResource.getMessage("common.buttons.remain_on_page"));

    registerChangeableControl(form().weekStartDay);
    registerChangeableControl(form().workdayDurationStr);

    registerChangeableControl(form().defaultTimeZone);

    registerChangeableControl(document.getElementById('decimalSeparatorFieldCustom'));
    registerChangeableControl(document.getElementById('decimalSeparatorFieldPredefined'));
    registerChangeableControl(document.getElementById('digitGroupingSymbolFieldCustom'));
    registerChangeableControl(document.getElementById('digitGroupingSymbolFieldPredefined'));

    var settingsForm = document.getElementById('settingsForm');

    registerFormChangedHandlers(true);

    setSubmitHandler(doSubmit);
    var wdInputs = workdayDurationsEditor.getInputs();
    for( var i = 0; i < wdInputs.length; i++ )
        registerChangeableControl( wdInputs[i] );

    if ( ptoRulesEditor != null )
       registerChangeableInputsBalancesEditors(ptoRulesEditor);
    if ( sickRulesEditor != null )
       registerChangeableInputsBalancesEditors(sickRulesEditor);
}

function registerChangeableInputsBalancesEditors(editor){
    var rulesInputs = editor.getInputs();
    for( var i = 0; i < rulesInputs.length; i++ )
        registerChangeableControl( rulesInputs[i] );
}

function form()
{
    return document.forms["GeneralSettingsForm"];
}

function onCustomFieldsChange()
{
    if (validateFormatFields())
    {
        onNumberFormatChange();
    }
}

function initWorkdayDurationsEditor( wdDurations, wdWeekStartDay )
{
    var edTotalEl = document.getElementById("weekTotalPlaceholder" );
    var wdChangesCallback = function( dayIdx, value, durations ) {
        form().elements["defaultWorkSchedule[" + dayIdx + "]"].value = value;
        if ( !workdayDurationsEditor.hasErrors() )
            edTotalEl.innerHTML = UserTime.formatTime( WorkdayDurationsEditor.sumDurations( durations ) );
        scheduleModificationsHandler.showInfo();
        updateWorkdayDurationsLabelErrorState();
    };
    workdayDurationsEditor = new WorkdayDurationsEditor().init( wdDurations, wdWeekStartDay, wdChangesCallback, true );
    updateWorkdayDurationsEditorTooltip();
    workdayDurationsEditor.renderTo( document.getElementById("workdayDurationsEditorPlaceholder") );
    edTotalEl.innerHTML = UserTime.formatTime( WorkdayDurationsEditor.sumDurations( wdDurations ) );
    form().weekStartDay.onchange = function()
    {
        var wdEditorPlaceholder = document.getElementById( "workdayDurationsEditorPlaceholder" );
        wdEditorPlaceholder.innerHTML="";
        workdayDurationsEditor.setWeekStartDay( this.value );
        workdayDurationsEditor.renderTo( wdEditorPlaceholder );
    };

    scheduleModificationsHandler = new ModificationsHandler().init(
                                       "scheduleModificationsInfo",
                                       workdayDurationsEditor.getDurations(),
                                       function(initValues) {
                                           workdayDurationsEditor.setDurations( initValues );
                                           workdayDurationsEditor.updateUI();
                                           edTotalEl.innerHTML = UserTime.formatTime( WorkdayDurationsEditor.sumDurations( initValues ) );
                                           updateWorkdayDurationsLabelErrorState();
                                       },
                                       true
    );
}

function updateWorkdayDurationsEditorTooltip()
{
    var invalidTooltipMessage = messageResource.getMessage("general_settings.edit.js.invalid_workday_duration", [SystemSettings.decimalSeparator] );
    workdayDurationsEditor.setInvalidTooltipMessage( invalidTooltipMessage );
}

function updateWorkdayDurationsLabelErrorState()
{
    updateLabelErrorState( "workScheduleLabel", workdayDurationsEditor.hasErrors(),
                           messageResource.getMessage("general_settings.edit.js.invalid_workday_duration", [SystemSettings.decimalSeparator] ) );
}


function updateBalanceRulesLabelErrorState(prefixLabel, balanceRulesEditor){
    updateLabelErrorState( prefixLabel + "RulesLabel", balanceRulesEditor.hasErrors(),
                           messageResource.getMessage("common.js.invalid_number", [SystemSettings.decimalSeparator] ) );
}

function updateLabelErrorState( labelId, hasErrors, errorMessage )
{
    var labelEl = document.getElementById( labelId );
    if ( hasErrors )
        ClientSideErrors.markFieldLabelsAsInvalid( labelEl, errorMessage, null, true );
    else
        ClientSideErrors.markFieldLabelsAsValid( labelEl, null, true );
}

function initLowBalanceRulesEditor(prefix, values, workdayDuration, showPTOInHours, product, isProductsIntegrated){
    // do not delete - used in other files
    window[prefix + "RulesEditor"] = initBalanceRulesEditor(prefix, values, workdayDuration, showPTOInHours )

    const LowBalanceSettingsContainer = prefix === 'pto' ? PtoLowBalanceSettingsContainer : SdbLowBalanceSettingsContainer

    const lowBalanceSettings = new LowBalanceSettingsContainer({product, isProductsIntegrated}).init($(`#${prefix}LowBalanceSettingsSection`))

    lowBalanceSettings.setUnits($(`#${prefix}ShowInDays`)[0].checked ? LeaveBalanceUnits.DAYS : LeaveBalanceUnits.HOURS)

    $(`#${prefix}ShowInDays`).on("click", () => lowBalanceSettings.setUnits(LeaveBalanceUnits.DAYS));
    $(`#${prefix}ShowInHours`).on("click", () => lowBalanceSettings.setUnits(LeaveBalanceUnits.HOURS));

    udpateDefaultWorkDayDuration((timeVal) => lowBalanceSettings.setWorkdayDuration(timeVal));
    $("#workdayDurationId" ).blur(() =>
        udpateDefaultWorkDayDuration((timeVal) => lowBalanceSettings.setWorkdayDuration(timeVal))
    );
}

function initBalanceRulesEditor(prefix, values, workdayDuration, showPTOInHours, errorHandler  )
{
    var balanceRulesEditor = new BalanceRulesEditor({
        balanceRulesTypePrefix: prefix,
        changesCallback: function() {
            handleChange(true)
            balanceModificationsHandler.showInfo()
            updateBalanceRulesLabelErrorState(prefix, balanceRulesEditor)
        },
    })

    new BalanceRulesEditorContent({
        balanceRulesEditorComponent: balanceRulesEditor,
        leaveBalanceTypePrefix: prefix,
    }).init($('#' + prefix + '_balanceRulesEditorPlaceholder'))

    balanceRulesEditor.setWorkdayDuration( workdayDuration );
    balanceRulesEditor.setValues( values );
    balanceRulesEditor.setBalanceUnits( showPTOInHours ? LeaveBalanceUnits.HOURS : LeaveBalanceUnits.DAYS );

    $("#workdayDurationId" ).blur(() =>
        udpateDefaultWorkDayDuration((timeVal) => balanceRulesEditor.setWorkdayDuration(timeVal))
    );

    var balanceModificationsHandler = new ModificationsHandler().init(
            prefix + "LeaveBalanceModificationsInfo",
            balanceRulesEditor.getValuesAsMap(),
            function(initValues) {
                balanceRulesEditor.accrueMonthDayButton.setActiveItemByPosition(0);
                balanceRulesEditor.accrueWeekdayButton.setActiveItemByPosition(0);
                balanceRulesEditor.setValues(initValues);
                updateBalanceRulesLabelErrorState(prefix, balanceRulesEditor);
            },
            true
    );

    $("#" + prefix + "ShowInDays" ).on("click", function(){
        balanceRulesEditor.setBalanceUnits(LeaveBalanceUnits.DAYS);
        updateBalanceRulesLabelErrorState(prefix, balanceRulesEditor);
    });

    $("#" + prefix + "ShowInHours" ).on("click", function(){
        balanceRulesEditor.setBalanceUnits(LeaveBalanceUnits.HOURS);
        updateBalanceRulesLabelErrorState(prefix, balanceRulesEditor);
    });
    return balanceRulesEditor;
}

function udpateDefaultWorkDayDuration(callback) {
    var value = $("#workdayDurationId" ).val();
    var timeVal = UserTime.parseTimeWithSystemSettings(value.length > 6 ? value.substring(0, 6) : value);
    if (timeVal != null && timeVal > 0) {
        callback(timeVal)
    }
}

function initDefaultTZGroupTimeZoneSelector(placeId, cityName, tzId, rawOffset)
{
    var initCity =
    {
        name: cityName,
        timeZoneId: tzId,
        rawOffset: rawOffset
    };
    var defaultTZGroupTimeZoneSelector = new TimeZonesSelector().init(
            $('#' + placeId),
            initCity,
            function(city){
                form()['defaultTZGroupTimeZoneId'].value = city.timeZoneId;
                form()['defaultTZGroupCityName'].value = city.name;
                form()['defaultTZGroupCityPlaceId'].value = city.placeId;
                updateDefaultTZGroupTime(city.currentTime);
                var tzDefaultGroupField = form()['defaultTZGroupName'];
                defaultTZGroupNameController.hideGrayTextIfShown();
                if(trim(tzDefaultGroupField.value) == "")
                {
                    tzDefaultGroupField.value = city.name.substring(0,40); //update group name if empty
                    checkDefaultTZGroupNameField(false);
                }
                defaultTZGroupNameController.showGreyTextIfEmpty();
                handleChange(true);
            }
    );
}

/**
 * Set current time for default timezone group/ timezone
 * @param currentTime time in common app format
 */
function updateDefaultTZGroupTime(currentTime)
{
    //set date on placeholder
    var date = Date.parseJSONTimeWithoutTimeZone(currentTime);
    var curDateElement = $("#currentTimeForSelectedCity");
    curDateElement.attr("notFormattedTime", currentTime);
    var dateFormat = curDateElement.attr("currentDateFormat");
    if(!dateFormat)
    {
        dateFormat = SystemSettings.dateFormat;
    }
    var clockFormat = curDateElement.attr("currentClockFormat");
    if(!clockFormat)
    {
        clockFormat = SystemSettings.clockFormat;
    }
    curDateElement.empty().text(new DateFormat(dateFormat, clockFormat).formatDateTime( date ));
}

function updateDefaultTZGroupTimeFormat(newDateFormat, newClockFormat)
{
    var curDateElement = $("#currentTimeForSelectedCity");
    var notFormattedTime = curDateElement.attr("notFormattedTime");
    if(notFormattedTime) {
        curDateElement.empty().text(new DateFormat(newDateFormat, newClockFormat).formatDateTime( Date.parseJSONTimeWithoutTimeZone(notFormattedTime) ));
    }
}

function checkDefaultTZGroupNameField(showError)
{
    var defaultTZGroupNameField = form()['defaultTZGroupName'];
    if (trim(defaultTZGroupNameField.value) == "")
    {
        if(showError)
        {
            ClientSideErrors.markTextFieldAsInvalid(defaultTZGroupNameField, messageResource.getMessage("general_settings.edit.empty_default_tz_group_name"));
        }
        return false;
    }
    else
    {
        ClientSideErrors.markTextFieldAsValid(defaultTZGroupNameField);
        return true;
    }
}

function switchTimeZoneAndTimeZoneGroupsElements(withTZGroups)
{
    var block = $("#dateTimeSettingsBlock");
    if(withTZGroups)
    {
        block.find(".withoutGroupsEl").hide();
        block.find(".withGroupsEl").show();
    } else
    {
        block.find(".withoutGroupsEl").show();
        block.find(".withGroupsEl").hide();
    }
}

function initDWDModificationsHandler()
{
    defaultWDModificationsHandler = new ModificationsHandler().init(
            "dwdModificationsInfo",
            $("#workdayDurationId" ).val(),
            function(initValues) {
                $("#workdayDurationId" ).val(initValues);
                ClientSideErrors.markTextFieldAsValid(form().workdayDurationStr);
                hideClientSideErrorMessageIfNoErrors();
                ClientSideErrors.markFieldLabelsAsValid(document.getElementById(form().workdayDurationStr.name+"FieldLabel"));
                if(ptoRulesEditor)
                    ptoRulesEditor.setWorkdayDuration( UserTime.parseTimeWithSystemSettings( initValues ) );
                if(sickRulesEditor)
                    sickRulesEditor.setWorkdayDuration( UserTime.parseTimeWithSystemSettings( initValues ) );
            },
            false
    );
    $("#workdayDurationId" ).blur( function() {
        if( this.value != this.defaultValue)
            defaultWDModificationsHandler.showInfo();
    } );

}

function checkDuration(field, limit = false)
{
    var timeVal = UserTime.parseTimeWithSystemSettings(field.value.length > 6 ? field.value.substring(0, 6) : field.value);
    if (timeVal != null && timeVal > 0 && !(limit && timeVal > 1440)) {
        field.value = UserTime.formatTime(timeVal);
        ClientSideErrors.markTextFieldAsValid(field);
        hideClientSideErrorMessageIfNoErrors();
        ClientSideErrors.markFieldLabelsAsValid(document.getElementById(field.name+"FieldLabel"));
    } else {
        ClientSideErrors.markTextFieldAsInvalid(field,
                                                messageResource.getMessage("general_settings.edit.invalide_time_format", [SystemSettings.decimalSeparator]));
        ClientSideErrors.markFieldLabelsAsInvalid(document.getElementById(field.name+"FieldLabel"),
                                                  messageResource.getMessage("general_settings.edit.invalide_time_format", [SystemSettings.decimalSeparator]));
    }
}

function baseOpenSectionsWithErrors()
{
    if (ptoRulesEditor != null && ptoRulesEditor.hasErrors())
        sectionsStateController.showBlock("ptoBlock");

    if (sickRulesEditor != null && sickRulesEditor.hasErrors())
        sectionsStateController.showBlock("sickBlock");

    ValidatableFormBlocks.getErrorBlockIds().forEach(id => sectionsStateController.showBlock(id));

    sectionsStateController.baseOpenSectionsWithErrors(fieldErrors);
}

function createFieldController(fieldId, emptyCaption)
{
    var fieldController = new FieldController();
    fieldController.emptyCaption = emptyCaption;
    fieldController.init(fieldId);
    fieldController.setDefaultValueIfNeeded();
    return fieldController;
}





function ModificationsHandler() {}

/*
 * param undoCallback - function(initValues)
 * param useCopyOfInitValues - if true then initValues will be used by value, not by reference
 */
ModificationsHandler.prototype.init = function( modificationsInfoId, initValues, undoCallback, useCopyOfInitValues )
{
    this.modificationsInfoElement = $("#"+modificationsInfoId );
    this.useCopyOfInitValues = useCopyOfInitValues;
    this.initValues = this.copyValuesIfNeeded( initValues );
    this.undoCallback = undoCallback;
    var self = this;
    this.modificationsInfoElement.find(".undoModifications").click(function() {
        self.undoCallback( self.copyValuesIfNeeded( self.initValues ) );
        self.hideInfo();
    });
    return this;
};

ModificationsHandler.prototype.showInfo = function(  )
{
    this.modificationsInfoElement.show();
};

ModificationsHandler.prototype.hideInfo = function(  )
{
    this.modificationsInfoElement.hide();
};

ModificationsHandler.prototype.copyValuesIfNeeded = function( values )
{
    var newValues = values;
    if ( this.useCopyOfInitValues )
    {
        if ( $.isArray( values ) )
            newValues = values.slice();
        else
            newValues = $.extend(true, {}, values);
    }
    return newValues;
};

const exported = {
    ValidatableFormBlocks,
    baseCanSubmit,
    doSubmit,
    baseRegisterChangeable,
    form,
    onCustomFieldsChange,
    initWorkdayDurationsEditor,
    updateWorkdayDurationsEditorTooltip,
    updateWorkdayDurationsLabelErrorState,
    updateLabelErrorState,
    initLowBalanceRulesEditor,
    initDefaultTZGroupTimeZoneSelector,
    updateDefaultTZGroupTime,
    updateDefaultTZGroupTimeFormat,
    checkDefaultTZGroupNameField,
    switchTimeZoneAndTimeZoneGroupsElements,
    initDWDModificationsHandler,
    checkDuration,
    baseOpenSectionsWithErrors,
    createFieldController,
    ModificationsHandler,
}

//this functions used in jsp, add them to window. get rid of this when Settings page became js module, i.e. in the very distant future
Object.keys(exported).forEach(fn => window[fn] = exported[fn])


// WEBPACK FOOTER //
// ./web/js/base_settings.js